<template>
    <el-dialog title="关联工单" :visible.sync="visible" @close="close" width="80%">
        <el-row class="bottom20">
            <el-table ref="incidentRelationTableRef" :data="tableData" @selection-change="handleSelectionChange">
                <el-table-column
                        type="selection"
                        width="55">
                </el-table-column>
                <el-table-column prop="dcnum" label="数据中心">
                    <template slot="header" slot-scope="scope">
                        数据中心<br>
                        <SysroomSelectNew v-model="searchParams.dcnum" @fetchAllSysrooms="fetchAllSysrooms"
                                          clearable filterable size="mini"></SysroomSelectNew>
                    </template>
                    <template slot-scope="scope">
                        {{formatRoom(scope.row.dcnum)}}
                    </template>
                </el-table-column>
                <el-table-column prop="ticketid" label="编号">
                    <template slot="header" slot-scope="scope">
                        编号<br>
                        <el-input size="mini" class="width70"
                                  v-model="searchParams.ticketid"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="description" label="名称">
                    <template slot="header" slot-scope="scope">
                        名称<br>
                        <el-input size="mini" class="width70"
                                  v-model="searchParams.description"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="actualstart" label="事件开始时间" width="340px">
                    <template slot="header" slot-scope="scope">
                        开始时间<br>
                        <div style="display: flex;flex-direction: row;align-items: center;">
                            <el-date-picker v-model="startTime" placeholder="开始时间从"
                                size="small"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                class="custom-date-picker"
                                style="width: 140px;"
                            />
                            <span style="margin: 0 5px;">~</span>
                            <el-date-picker
                                v-model="endTime"
                                placeholder="到"
                                size="small"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                class="custom-date-picker"
                                style="width: 140px;"
                            />
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>

        <el-row type="flex" class="row-bg" justify="end">
            <el-pagination align="right" @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="currentPage"
                           :page-sizes="pageSizes" :page-size="pageSize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </el-row>

        <br>

        <el-row style="text-align: right">
            <el-button center="true" type="primary" @click="btnRelationHandler">确定</el-button>
            <el-button center @click="close">关闭</el-button>
        </el-row>
    </el-dialog>
</template>

<script>

    import SysroomSelectNew from '@/components/sysroomNew'
    import RelationServer from "@/api/relation/relation";
    import TicketServer from "@/api/ticket";
    import {formatDate} from "element-ui/src/utils/date-util";

    export default {
        name: "incidentRelationDialog",

        components: {
            SysroomSelectNew,

        },

        props: {
            visible: {
                type: Boolean,
            },
            searchParams: {
                type: Object,
            },
            masterInfo: {
                type: Object,
            },
        },

        data() {
            return {
                tableData: [],

                currentPage: 1,
                pageSize: 10,
                pageSizes: [10, 25, 50, 100],
                total: 0,

                dcnums: [],
                startTime: null,
                endTime: null,
                relationArray: [],
            }
        },
        created() {
            this.startTime = formatDate(new Date(new Date().getTime() - 24 * 60 * 60 * 1000), 'yyyy-MM-dd')
            this.endTime = formatDate(new Date(), 'yyyy-MM-dd')
        },

        methods: {
            close() {
                this.$emit('update:visible', false);
            },

            fetchAllSysrooms(rooms) {
                this.dcnums = rooms;
            },

            formatRoom(dcnum) {
                let roomDesc = '';
                this.dcnums.forEach(e => {
                    if (dcnum == e.id) {
                        roomDesc = e.name;
                    }
                });
                return roomDesc;
            },

            handleSizeChange(val) {
                this.pageSize = val;
                this.queryTable();
            },

            handleCurrentChange(val) {
                this.currentPage = val;
                this.queryTable();
            },

            queryTable() {
                let params = {
                    'iDisplayStart': this.currentPage,
                    'iDisplayLength': this.pageSize,
                    'conditions': JSON.stringify({
                        ...this.searchParams,
                        startTime: this.startTime,
                        endTime: this.endTime,
                    }),
                    'appId': 'WEB',
                    'token': localStorage.getItem("token")
                };
                TicketServer.ticket.page(params, {'loading': true}).then(res => {
                    if (res.data.code == 200) {
                        this.tableData = res.data.aaData;
                        this.total = res.data.iTotalRecords;
                    }
                });
            },

            handleSelectionChange(arr) {
                console.log(arr)
                console.log(this.masterInfo)
                const masterRoom = this.dcnums.find(d => +d.id === +this.masterInfo.dcnum);
                console.log(masterRoom)
                this.relationArray = [];
                for (let i = 0; i < arr.length; i++) {
                    const room = this.dcnums.find(d => +d.id === +arr[i].dcnum);
                    this.relationArray.push({
                        'clazz': this.masterInfo.clazz,
                        'enterby': this.masterInfo.enterby,
                        'enterdate': this.masterInfo.enterdate,
                        'orgid': this.masterInfo.orgid,
                        'siteid': this.masterInfo.siteid || (masterRoom ? masterRoom.siteid : ''),
                        'recordkey': this.masterInfo.recordkey,
                        'relatedrecclass': this.masterInfo.relatedrecclass,
                        'relatedreckey': arr[i].ticketid,
                        'relatedrecorgid': arr[i]['orgid'],
                        'relatedrecsiteid': arr[i]['siteid'] || room ? room.siteid : '',
                        'relatetype': this.masterInfo.relatetype,
                        'validation': this.masterInfo.validation,
                    });
                    this.relationArray.push({
                        'clazz': this.masterInfo.relatedrecclass,
                        'enterby': this.masterInfo.enterby,
                        'enterdate': this.masterInfo.enterdate,
                        'orgid': arr[i]['orgid'],
                        'siteid':  arr[i]['siteid'] || room ? room.siteid : '',
                        'recordkey': arr[i].ticketid,
                        'relatedrecclass': this.masterInfo.clazz,
                        'relatedreckey': this.masterInfo.recordkey,
                        'relatedrecorgid': this.masterInfo.orgid,
                        'relatedrecsiteid': this.masterInfo.siteid || (masterRoom ? masterRoom.siteid : ''),
                        'relatetype': this.masterInfo.relatetype,
                        'validation': this.masterInfo.validation,
                    });
                }
            },

            btnRelationHandler() {
                if(this.relationArray.length === 0)
                    return this.$message.warning('请选择至少一条数据')
                RelationServer.batchRelation(this.relationArray).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success('关联成功');
                        this.$emit('afterRelation');
                        this.close();
                    } else {
                        this.$message.error(res.data.message);
                    }
                });
            },
        },

        watch: {
            startTime: {
                handler: function (val) {
                    if(Date.parse(val) > Date.parse(this.endTime)) {
                        return this.$message.warning('开始时间不能大于结束时间')
                    }
                    this.queryTable();
                }
            },
            endTime: {
                handler: function (val) { 
                    if(Date.parse(this.startTime) > Date.parse(val)) {
                        return this.$message.warning('开始时间不能大于结束时间')
                    }
                    this.queryTable();
                }
            },
            searchParams: {
                deep: true,
                handler: function (newVal, oldVal) {
                    this.currentPage = 1;
                    this.total = 0;
                    this.tableData = [];

                    this.queryTable();
                }
            }
        },
    }
</script>

<style scoped>

</style>
